import createSvgIcon from "./utils/create_icon"

const TrashFill = createSvgIcon(<path clipRule="evenodd" d="M11 3a3 3 0 0 0-3 3v1H4a1 1 0 0 0 0 2h1v9a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V9h1a1 1 0 1 0 0-2h-4V6a3 3 0 0 0-3-3zm3 4h-4V6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1zm-4 4a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1z" fill="currentColor" fillRule="evenodd" />, "TrashFill")
export default TrashFill
